$(document).ready(function() {
    var appComponent = new AppComponent();
});

